import { Box, Paper } from "@mui/material";
import { Logo } from "components";

export const TopLogoPanel = ({ children = "", elevation = 6, ...props }) => {
  return (
    <div className="relative w-full">
      <Box
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        className="absolute w-full transform -translate-y-1/2 flex justify-center"
      >
        <Logo shadow size="tiny" />
      </Box>
      <div className="relative w-full">
        <Paper className="sm:p-10 sm:pt-20 p-5 pt-20" elevation={elevation}>
          {children}
        </Paper>
      </div>
    </div>
  );
};
